import { Box, Divider } from '@mui/material'
import { Typography } from '@singcolor/components'
import React, { FC } from 'react'
import { DownloadOnAppStore, DownloadOnGooglePlay } from 'src/components/atoms/downloadButton'
import { UserThumbnail } from 'src/components/atoms/UserThumbnail'
import { useIsTwitterWebView } from 'src/modules/user_agent/hooks'

type Props = {
  liverName: string
  liverProfileImageUrl: string | undefined
}

export const ShareLiverInfo: FC<Props> = ({ liverName, liverProfileImageUrl }) => {
  const isTwitterWebView = useIsTwitterWebView()

  return (
    <Box sx={{ minHeight: '100svh' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: '16px',
          pt: '32px'
        }}
      >
        <Box sx={{ width: 1, display: 'flex', justifyContent: 'center', mb: '32px' }}>
          <img src="/assets/logo.png" height="40px" width="auto" />
        </Box>

        <UserThumbnail
          imageURLs={{ extraSmall: '', small: '', medium: '', large: liverProfileImageUrl ?? '' }}
          size="128px"
        />
        <Typography variant="h4" sx={{ mt: '16px' }}>
          {liverName} が歌配信中！
        </Typography>

        {isTwitterWebView ? (
          <Typography variant="body2" textAlign={'center'} sx={{ mt: '24px' }}>
            Xからこのページを見ている方は画面下の
            <br />
            「colorsing.com ︙」から「ブラウザで開く」
            <br />
            をタップ！
          </Typography>
        ) : (
          <Box>
            <Typography variant="body2" textAlign={'center'} sx={{ mt: '24px' }}>
              アプリを開いています...
            </Typography>
            <Divider sx={{ my: '24px' }} />
            <Typography variant="body2" textAlign={'center'}>
              はじめての方はアプリをインストール！
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                mt: '12px'
              }}
            >
              <DownloadOnAppStore height="48px" />
              <DownloadOnGooglePlay height="46px" />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}
